import { React, useEffect, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetEpbDownloadForceWiseEciReportMutation,useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils";
import pdfIcon from "../../../images/pdfIcon.png";
import excelIcon from "../../../images/excelIcon.png";
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";
const tableHeader = [
  "Force /Wing Name",
  "Total e-PB generated",
  "Total e-PB downloaded",
  "Total e-PB PIN downloaded",
];

const selectConstituencyType = [
  { value: "", label: "Select Constituency" },
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const stateList = [{ value: "", label: " Select Phase" }];

const EpbDownloadingForceWiseEciReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Downloading Report Force Wise"
  const SheetName = "Force Wise Report"
  const [ Error,setError] = useState({});
  const [states, setStates] = useState({
    stateValue:"",
    constTypeValue:"",
  })
  const tableHeader = [];
  const columns = [
    {
      Header: "Force/Wing Name",
      accessor: "col2",
    },
    {
      Header: "Total e-PB Generated",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Downloaded",
      accessor: "col4",
    },
    {
      Header: "Total e-PB PIN Downloaded",
      accessor: "col5",
    },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })
  // const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [getReports] = useGetEpbDownloadForceWiseEciReportMutation()
  const [tableData,setTableData] = useState([]);

  useEffect(()=>{
    const Phases = JSON.parse(localStorage?.phaseList)
    Phases.map((item)=>{
      stateList.push({value:item, label:item})
    })
 console.log(stateList)
   },[])

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  // getElectionAnnouncedState?.payload?.map((item) => {
  //   stateList?.push({
  //     value: item.stateCd,
  //     label: item.stateName,
  //   });
  // });
  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
 
  const renderTableData = () => {
    let error = {};
    if (!states.stateValue || states.stateValue === "" || states.stateValue.length == 0) {
      error["stateValue"] = "This Field is required"
    }
    if (!states.constTypeValue || states.constTypeValue === "" || states.constTypeValue.length == 0) {
      error["constTypeValue"] = "This Field is required"
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    let payload = {
      "stateCd": states.stateValue,
      "constType": states.constTypeValue
    }
      getReports(payload)
        .unwrap()
        .then((res) => {
          let tData = []
          res?.payload?.map((item) => {
            tData.push({
              "col2": item.forceName,
              "col3": item.uploadedEpbCount,
              "col4": item.downloadedEpbCount,
              "col5": item.downloadedEpbPinCount,
            });
          });
          setTableData(tData)
          setTotalNoOfRecords(res?.payload?.length)
        }).catch((error) => {
          if(error?.data?.message==="No record found")
          {
            
            setTableData([])
          }
        })
    
  };
  return (
    <LeftMenu>
    <div className="container box shadow ">
     <div className="row">
          <div className="col-md-12">
          <RunnerUpHeaderNew title={reportName} onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData, false )} 
          onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)}/>
          </div>
        </div>
      <div className="row">
          <SelectField
          labelClass=""
          inputClass="col-md-4"
          options={stateList}
          name="stateValue"
          value={states.stateValue}
          handleChange={(val) => handleChange("stateValue", val)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            }
          ]}

          getError={(val) => getError("stateValue", val)}
          Error={Error}
        ></SelectField>
        <SelectField
          labelClass=""
          inputClass="col-md-2 pr-1"
          name="constTypeValue"
          options={selectConstituencyType}
          value={states.constTypeValue}
          handleChange={(val) => handleChange("constTypeValue", val)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            }
          ]}

          getError={(val) => getError("constTypeValue", val)}
          Error={Error}
        ></SelectField>
        <div className="col-md-2 download_button">
        <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
        </div>
      </div>
      <div style={{marginTop:"-40px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              emptyMessage="No Record Found"
              columns={columns}
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
    </div>
    </LeftMenu>
  );
};
export default EpbDownloadingForceWiseEciReport;
